import React from "react";
import FridgePageTemplate from "./FridgePageTemplate";

const relatedLinks = [
  { to: "/fridge-service-bangalore", label: "Refrigerator Service" },
  { to: "/fridge-not-cooling-repair", label: "Not Cooling Repair" },
  { to: "/fridge-gas-refill-service-bangalore", label: "Gas Refill Service" },
  { to: "/side-by-side-fridge-service-bangalore", label: "Side-by-Side Service" },
  { to: "/mini-fridge-service-bangalore", label: "Mini Fridge Service" },
];

const FridgeCompressorRepair = () => {
  return (
    <FridgePageTemplate
      title="Fridge Compressor Repair in Bangalore"
      description="Expert refrigerator compressor repair in Bangalore for noisy compressors, overheating, and cooling failures."
      keywords="fridge compressor repair bangalore, refrigerator compressor problem, fridge compressor service"
      path="/fridge-compressor-repair"
      bannerTitle="Fridge Compressor Repair"
      intro={
        <>
          When your fridge compressor is noisy, overheating, or not running correctly, our Bangalore technicians provide fast repair and replacement support for all refrigerator models.
        </>
      }
      highlights={[
        "Compressor diagnostics and repair",
        "Overheat protection checks",
        "Seal and electrical fault inspection",
        "Fast doorstep refrigerator service",
      ]}
      issues={[
        "Compressor not starting",
        "Loud humming or rattling noise",
        "Compressor overheating",
        "Fridge not cooling due to compressor fault",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default FridgeCompressorRepair;

